export function initializeAccordion() {
    const accordions = document.querySelectorAll('.accordion-item');

    accordions.forEach(item => {
        const trigger = item.querySelector('.accordion-trigger');
        
        trigger.addEventListener('click', () => {
            // Checken, ob das aktuelle Item bereits offen ist
            const isOpen = item.classList.contains('is-open');

            // 1. Alle Items schließen (Reset)
            accordions.forEach(acc => {
                acc.classList.remove('is-open');
                const btn = acc.querySelector('.accordion-trigger');
                btn.setAttribute('aria-expanded', 'false');
            });

            // 2. Wenn das geklickte Item NICHT offen war -> Öffnen
            if (!isOpen) {
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
            }
        });
    });
}

